
import './App.css';
//import Chess from "chess.js";
import React, {useState,useEffect,useRef} from "react"
import ChessBoard from "chessboardjsx";
import Chess from "chess.js"
import WithMoveValidation from './integrations/WithMoveValidation';
import Demo from './Demo';

//import { ChessInstance,ShortMove } from "chess.js";
const container = {
  marginTop: "2rem",
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
  position: "relative"
}
//const chess = require("chess.js");
function App() {
  //const startPos = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";
  const [fen,setFen] = useState("start")
  let game = useRef(null);

  useEffect(() => {
    game.current = new Chess();
  },[])
  const onDrop =({sourceSquare, targetSquare}) => {
    let move = game.current.move({
      from: sourceSquare,
      to: targetSquare
    })
    if(move === null) return; //check for illegal moves
    
    
    //provide the fen string

    setFen(game.current.fen())
  }
  const resetGame = () => {
    game.current.clear();
    game.current.reset();
    setFen("start");
  }
  const onPieceClick = () => {
    
  }
  
  

  
  
    
  return (
    <div style={backStyle} className="back">
    
      {
        game.current && game.current.game_over()
        ? <div style={{textAlign: 'center'}}><h1>Game Over</h1>
        <button onClick={resetGame} className="cursor-pointer">new Game?</button>
        </div>
        :
        <span></span>
      }
      <h1 className="title">Let's Play Some Chess</h1>
    <div className="app" style={container}>
      
    <Demo />
    
      
      
    </div>
    </ div>   
  );
    
    }
  
export default App;
const backStyle = {
  backgroundcolor: "lightblue",
  position: "relative",
  alignItems: "center",
  
};
/*<ChessBoard
         position={fen}
         onDrop={onDrop}
         onPieceClick={onPieceClick}
      /> */